<template>
  <div class="reset col-xl-4 mx-auto" @keyup.enter="resetPassword">
    <h3 class="mb-4">Reset your password</h3>
    <b-form-group label="Email" :state="IsFieldValid($v.email)" :invalid-feedback="RequiredMessage('Email', $v.email)">
      <b-form-input v-model="$v.email.$model" :state="IsFieldValid($v.email)" />
    </b-form-group>
    <b-form-group label="New Password" :state="IsFieldValid($v.newPassword)" :invalid-feedback="PasswordMessage('New Password', $v.newPassword)">
      <b-form-input v-model="$v.newPassword.$model" :state="IsFieldValid($v.newPassword)" type="password" />
    </b-form-group>
    <b-form-group label="Confirm New Password" :state="IsFieldValid($v.confirmPassword)" invalid-feedback="Passwords must match.">
      <b-form-input v-model="$v.confirmPassword.$model" :state="IsFieldValid($v.confirmPassword)" type="password" />
    </b-form-group>
    <b-button @click="resetPassword" variant="success">
      Reset Password
    </b-button>
    <b-alert show variant="danger" v-if="error" class="text-left mt-3">
      <p class="mb-0">{{ error }}</p>
    </b-alert>
  </div>
</template>

<script>
import UserService from '../services/UserService.js'
import { required, email, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
import CustomValidations from '../mixins/customValidations.js'
const pwValidation = CustomValidations.passwordValidation

export default {
  name: 'ResetPassword',
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      email: '',
      newPassword: '',
      confirmPassword: '',
      error: ''
    }
  },
  validations() {
    return {
      email: { 
        required, 
        email 
      },
      newPassword: { 
        required, 
        pwValidation,
        minLength: minLength(15),
        maxLength: maxLength(60)
      },
      confirmPassword: {
        sameAsPassword: sameAs(function() {
          return this.newPassword
        })
      }
    }
  },
  methods: {
    resetPassword() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      UserService.resetPassword(this.email, this.newPassword, this.token).then(res => {
        this.$store.dispatch('user/setUserData', res.data).then(() => {
          this.$router.push({
            name: 'home'
          })
        })
      }).catch(() => {
        this.error = 'Password could not be reset.'
      })
    }
  }
}
</script>